import { motion } from "framer-motion";
import { ShieldCheck, Gem, Crosshair, Clock } from "lucide-react";

const FEATURES = [
  { icon: Crosshair, title: "Precision Craftsmanship", text: "Computer-cut patterns and hand-finished edges for a seamless, bubble-free result every time." },
  { icon: Gem, title: "Premium Materials", text: "Only top-tier ceramic and carbon films engineered for clarity, heat rejection and longevity." },
  { icon: ShieldCheck, title: "Uncompromising Quality", text: "Backed by workmanship guarantees and warranty-eligible products you can trust for years." },
  { icon: Clock, title: "Respect For Your Time", text: "Clear quotes, honest timelines and a clean, professional shop experience from start to finish." },
];

const STATS = [
  { value: "100%", label: "Satisfaction Focus" },
  { value: "UV 99%", label: "Blocked By Our Film" },
  { value: "2026", label: "Established" },
];

export const WhyUs = () => {
  return (
    <section id="about" data-testid="about-section" className="relative py-24 md:py-32 bg-[#070707] border-y border-white/5">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <span className="text-xs tracking-[0.3em] uppercase text-gold font-bold font-mono-x">Why AS Auto Works</span>
            <h2 className="font-heading font-bold uppercase tracking-tight text-4xl sm:text-5xl mt-4 text-white leading-tight">
              Built On <span className="gold-gradient-text">Detail.</span> Obsessed With Finish.
            </h2>
            <p className="text-neutral-400 mt-6 text-base lg:text-lg leading-relaxed">
              We started AS Auto Works with one belief: the difference between good and great is in
              the details nobody else notices. From the first measurement to the final squeegee pass,
              your vehicle gets our full focus.
            </p>

            <div className="grid grid-cols-3 gap-4 mt-10">
              {STATS.map((s) => (
                <div key={s.label} data-testid={`stat-${s.label.toLowerCase().replace(/\s+/g, "-")}`} className="border-l border-[#D4AF37]/40 pl-4">
                  <div className="font-heading font-black text-2xl md:text-3xl gold-gradient-text">{s.value}</div>
                  <div className="text-[11px] uppercase tracking-wider text-neutral-500 mt-1">{s.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-5">
            {FEATURES.map((f, i) => (
              <motion.div
                key={f.title}
                data-testid={`feature-${i}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="bg-[#0A0A0A] border border-white/10 p-7 hover:border-[#D4AF37]/40 hover:-translate-y-1 transition-all duration-500"
              >
                <f.icon size={32} className="text-gold" strokeWidth={1.4} />
                <h3 className="font-heading font-semibold text-xl uppercase text-white mt-5">{f.title}</h3>
                <p className="text-sm text-neutral-400 mt-3 leading-relaxed">{f.text}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
